export * from './home-page-view';
